import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 576px) {
    padding-top: 60px;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin: 50px;
  min-width: 1000px;
  @media screen and (max-width: 576px) {
    flex-direction: column;
    min-width: 300px;
  }
  img {
    width: 400px;
    height: 400px;
    color: ${({ theme }) => theme.color1};
    @media screen and (max-width: 576px) {
      width: 200px;
      height: 200px;
    }
  }
`;
export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;
export const Input = styled.input`
  margin-bottom: 20px;
  font-size: 2ch;
  padding: 10px;
  width: 400px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.color3};
  border: 1px solid
    ${({ valid, theme }) => (valid ? theme.color2 : theme.color1)};
  color: ${({ theme }) => theme.color4};
  @media screen and (max-width: 576px) {
    width: 300px;
  }
  :focus {
    outline: none;
    border: 2px solid
      ${({ valid, theme }) => (valid ? theme.color2 : theme.color1)};
  }
`;
export const Button = styled.button`
  padding: 5px;
  background-color: ${({ theme }) => theme.color3};
  color: ${({ theme }) => theme.color1};
  border: 3px solid ${({ theme }) => theme.color1};
  border-radius: 20px;
  font-size: 2.5ch;
  margin-top: 15px;
  /* transition: 0.5s ease-in-out; */
  :hover:enabled {
    cursor: pointer;
    background-color: ${({ theme }) => theme.color1};
    color: ${({ theme }) => theme.color3};
  }
  :disabled {
    border: 2px solid ${({ theme }) => theme.color1}3f;
    color: ${({ theme }) => theme.color1}3f;
  }
`;
export const ContactsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  min-width: 1000px;
  margin-bottom: 30px;
  margin-top: 50px;
  @media screen and (max-width: 576px) {
    flex-direction: column;
    min-width: 300px;
  }
`;

export const Contacts = styled.div`
  /* display: flex;
  flex-direction: column; */
`;
export const Contact = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  i {
    color: ${({ theme }) => theme.color1};
    margin-right: 20px;
    font-size: 20px;
  }
  p {
    color: ${({ theme }) => theme.color4};
  }
  a {
    color: ${({ theme }) => theme.color4};
    text-decoration: none;
  }
`;
export const H2 = styled.h2`
  text-transform: uppercase;
  color: ${({ theme }) => theme.color1};
  font-size: 2em;
  font-weight: bold;
  border-bottom: 5px solid;
  @media screen and (max-width: 576px) {
    margin-bottom: 30px;
  }
`;

// export const Button = styled.div``;
// export const Button = styled.div``;
